'use client';
import { createContext, useContext, useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [isNavigating, setIsNavigating] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const pathname = usePathname();

  // Анхны ачааллын төлөв
  useEffect(() => {
    // Сайтад анх орох үед loader харуулах
    setIsInitialLoading(true);
    
    // Хуудас бүрэн ачаалагдсаны дараа loader нуух
    const handleLoad = () => {
      setTimeout(() => {
        setIsInitialLoading(false);
      }, 300);
    };

    // Backup timer - хэрэв load event ирэхгүй бол
    const backupTimer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 2000);

    // Хэрэв хуудас аль хэдийн ачаалагдсан бол
    if (document.readyState === 'complete') {
      clearTimeout(backupTimer);
      handleLoad();
      return;
    }

    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('load', handleLoad);
      clearTimeout(backupTimer);
    };
  }, []);

  // Хуудас хооронд шилжих үед loading төлөв
  useEffect(() => {
    // Анхны ачааллын үед энэ эффектийг ажиллуулахгүй
    if (isInitialLoading) return;
    
    // Хуудас өөрчлөгдөх үед loading төлөвт оруулах
    setIsNavigating(true);
    
    // Хурдан хугацаа - content шууд харагдах
    const timer = setTimeout(() => {
      setIsNavigating(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [pathname, isInitialLoading]);

  return (
    <NavigationContext.Provider value={{ isNavigating, isInitialLoading, setIsNavigating }}>
      {children}
    </NavigationContext.Provider>
  );
}

export const useNavigation = () => useContext(NavigationContext);

